import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    margin: '15px'
  }
});
